import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Clock, TrendingUp, Package } from 'lucide-react';
import { SalesButton } from '../ui/SalesButton';
export function PricingBundles() {
  const [selected, setSelected] = useState(1);
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes
  const [stockLeft, setStockLeft] = useState(47);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const bundles = [{
    id: 0,
    name: 'Try It Out',
    bottles: 1,
    price: 39.99,
    originalPrice: 59.99,
    savings: '33% OFF',
    popular: false,
    supply: '30 Day Supply',
    perBottle: 39.99,
    mostChosen: false,
    checkoutUrl: 'https://glowliftessence.com/checkouts/cn/hWN7qlcBq5zqxPASnHiQUxsI/en-us?_r=AQABLSvuQnRna4ickqHugyalT1RLs5gt8mpMaK4uo1D_aJo&preview_theme_id=150187475134&skip_shop_pay=true'
  }, {
    id: 1,
    name: 'Most Popular',
    bottles: 3,
    price: 79.98,
    originalPrice: 179.97,
    savings: '56% OFF',
    popular: true,
    supply: '90 Day Supply',
    badge: 'Buy 2 Get 1 Free',
    perBottle: 26.66,
    mostChosen: true,
    savingsAmount: 99.99,
    checkoutUrl: 'https://glowliftessence.com/checkouts/cn/hWN7qleKH43aFj9rgpDOjJZ4/en-us?_r=AQABKcqyFcWKr4mkuUHjw2c6CC8F-duglU696GabABlpEXc&preview_theme_id=150187475134&skip_shop_pay=true'
  }, {
    id: 2,
    name: 'Ultimate Value',
    bottles: 5,
    price: 119.97,
    originalPrice: 299.95,
    savings: '60% OFF',
    popular: false,
    supply: '150 Day Supply',
    badge: 'Buy 3 Get 2 Free',
    perBottle: 23.99,
    mostChosen: false,
    savingsAmount: 179.98,
    checkoutUrl: 'https://glowliftessence.com/checkouts/cn/hWN7qltjAzVTavA6H4MD6qWI/en-us?_r=AQABAvkBIGHBoCr-M4bR3aFetQraHhud3u4PWwiAwSIJLAA&preview_theme_id=150187475134&skip_shop_pay=true'
  }];
  return <section id="pricing" className="py-24 bg-gradient-to-br from-[#1B5E20] to-[#14532D] text-white relative overflow-hidden" data-id="element-230">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-231">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle, #10B981 1px, transparent 1px)',
        backgroundSize: '30px 30px'
      }} data-id="element-232" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-233">
        {/* Urgency timer */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mb-8 text-center" data-id="element-234">
          <div className="inline-flex items-center space-x-3 bg-red-500 px-6 py-3 rounded-full shadow-2xl" data-id="element-235">
            <Clock className="w-5 h-5 animate-pulse" data-id="element-236" />
            <span className="font-bold" data-id="element-237">
              SPECIAL OFFER ENDS IN: {String(minutes).padStart(2, '0')}:
              {String(seconds).padStart(2, '0')}
            </span>
          </div>
        </motion.div>

        <div className="text-center mb-12" data-id="element-238">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-239">
            Choose Your Supply
          </h2>
          <p className="text-[#10B981] text-lg font-bold flex items-center justify-center space-x-2" data-id="element-240">
            <TrendingUp className="w-5 h-5" data-id="element-241" />
            <span data-id="element-242">Only {stockLeft} bottles left at this price!</span>
          </p>
        </div>

        {/* Product showcase with image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 max-w-4xl mx-auto" data-id="element-243">
          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 border-2 border-[#10B981]/30" data-id="element-244">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-245">
              <div className="relative" data-id="element-246">
                <div className="absolute inset-0 bg-[#10B981]/20 blur-3xl rounded-full" data-id="element-247"></div>
                <img src="https://cdn.magicpatterns.com/uploads/fmti55VufUKBbuVqKcuFFP/LymphoriaX.png" alt="LymphoriaX Bottle" className="relative z-10 w-full max-w-sm mx-auto drop-shadow-2xl" data-id="element-248" />
              </div>
              <div className="text-left" data-id="element-249">
                <h3 className="text-3xl font-bold mb-4" data-id="element-250">
                  What You're Getting:
                </h3>
                <ul className="space-y-3" data-id="element-251">
                  {['2 FL OZ (59 ML) per bottle', 'Liquid herbal extract formula', 'Easy-to-use dropper included', 'Natural ingredients, no fillers', 'Made in USA facility', 'Third-party tested for purity'].map((item, i) => <li key={i} className="flex items-center space-x-3" data-id="element-252">
                      <Check className="w-5 h-5 text-[#10B981] flex-shrink-0" data-id="element-253" />
                      <span data-id="element-254">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-end mb-12" data-id="element-255">
          {bundles.map((bundle, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} onClick={() => setSelected(index)} className={`
                relative rounded-2xl p-6 cursor-pointer transition-all duration-300
                ${bundle.popular ? 'bg-white text-[#1B5E20] transform scale-105 shadow-2xl z-10 border-4 border-[#10B981]' : 'bg-[#14532D] text-white border-2 border-[#10B981]/30 hover:border-[#10B981]/60'}
              `} data-id="element-256">
              {bundle.popular && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#10B981] text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg whitespace-nowrap animate-pulse" data-id="element-257">
                  🔥 BEST VALUE - SAVE ${bundle.savingsAmount}
                </div>}

              {bundle.mostChosen && <div className="absolute -top-4 right-4 bg-red-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg" data-id="element-258">
                  87% Choose This
                </div>}

              <div className="text-center mb-6" data-id="element-259">
                <div className={`text-xs font-bold uppercase tracking-wider mb-3 ${bundle.popular ? 'text-[#10B981]' : 'text-[#10B981]'}`} data-id="element-260">
                  {bundle.name}
                </div>

                {/* Product image in bundle */}
                <div className="mb-4 relative" data-id="element-261">
                  <div className="flex justify-center items-end space-x-1" data-id="element-262">
                    {[...Array(bundle.bottles)].map((_, i) => <motion.img key={i} initial={{
                  opacity: 0,
                  y: 20
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  delay: i * 0.1
                }} src="https://cdn.magicpatterns.com/uploads/fmti55VufUKBbuVqKcuFFP/LymphoriaX.png" alt="LymphoriaX Bottle" className={`${bundle.bottles === 1 ? 'w-20' : bundle.bottles === 3 ? 'w-16' : 'w-12'} drop-shadow-lg`} data-id="element-263" />)}
                  </div>
                </div>

                {bundle.badge && <div className="mb-3" data-id="element-264">
                    <div className="inline-block bg-[#10B981]/20 text-[#10B981] px-4 py-1 rounded-lg text-sm font-bold" data-id="element-265">
                      {bundle.badge}
                    </div>
                  </div>}

                <div className="mb-2" data-id="element-266">
                  <span className="text-4xl font-bold" data-id="element-267">${bundle.price}</span>
                  {bundle.originalPrice && <div className="text-sm line-through opacity-60 mt-1" data-id="element-268">
                      Was ${bundle.originalPrice}
                    </div>}
                </div>

                <div className={`text-sm font-bold ${bundle.popular ? 'text-[#10B981]' : 'text-[#10B981]'}`} data-id="element-269">
                  ${bundle.perBottle.toFixed(2)} per bottle
                </div>

                {bundle.savings && <div className="mt-3 inline-block bg-red-500 text-white px-4 py-1 rounded-full text-sm font-bold" data-id="element-270">
                    {bundle.savings}
                  </div>}
              </div>

              <div className="space-y-3 mb-8" data-id="element-271">
                <div className="flex items-center justify-center space-x-2 text-sm font-medium" data-id="element-272">
                  <Check className="w-5 h-5 text-[#10B981]" data-id="element-273" />
                  <span data-id="element-274">{bundle.supply}</span>
                </div>
                <div className="flex items-center justify-center space-x-2 text-sm font-medium" data-id="element-275">
                  <Check className="w-5 h-5 text-[#10B981]" data-id="element-276" />
                  <span data-id="element-277">Free US Shipping</span>
                </div>
                <div className="flex items-center justify-center space-x-2 text-sm font-medium" data-id="element-278">
                  <Check className="w-5 h-5 text-[#10B981]" data-id="element-279" />
                  <span data-id="element-280">60-Day Guarantee</span>
                </div>
                {bundle.savingsAmount && <div className="flex items-center justify-center space-x-2 text-sm font-bold" data-id="element-281">
                    <Check className="w-5 h-5 text-[#10B981]" data-id="element-282" />
                    <span data-id="element-283">Save ${bundle.savingsAmount}!</span>
                  </div>}
              </div>

              <a href={bundle.checkoutUrl} target="_blank" rel="noopener noreferrer" className="block" data-id="element-284">
                <SalesButton fullWidth variant={bundle.popular ? 'primary' : 'secondary'} className={!bundle.popular ? 'bg-[#10B981] hover:bg-[#059669]' : ''} onClick={e => e.stopPropagation()} data-id="element-285">
                  {bundle.popular ? 'Claim This Deal Now' : 'Add to Cart'}
                </SalesButton>
              </a>
            </motion.div>)}
        </div>

        {/* Trust badges */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto" data-id="element-286">
          {[{
          icon: '🔒',
          text: 'Secure Checkout'
        }, {
          icon: '✅',
          text: '60-Day Guarantee'
        }, {
          icon: '🚚',
          text: 'Free Shipping'
        }, {
          icon: '⭐',
          text: '12,847+ Reviews'
        }].map((item, i) => <div key={i} className="text-center" data-id="element-287">
              <div className="text-3xl mb-2" data-id="element-288">{item.icon}</div>
              <div className="text-sm font-medium" data-id="element-289">{item.text}</div>
            </div>)}
        </div>

        {/* Social proof */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-12 text-center" data-id="element-290">
          <div className="inline-flex items-center space-x-2 bg-[#14532D] px-6 py-3 rounded-full border border-[#10B981]/30" data-id="element-291">
            <div className="flex text-[#10B981]" data-id="element-292">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-293" />)}
            </div>
            <span className="text-sm font-medium" data-id="element-294">
              2,847 women purchased in the last 24 hours
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}